export default function sacUnitChange() {
    $("#selectUnits").on('change', function () {
        triggerPillar($(this).val());
        changeSubjects($(this));
    });

    function triggerPillar(option) {
        let pilares = document.querySelectorAll('.col-8 .pillars');

        // Esconde todos
        pilares.forEach(p => {
            p.classList.remove('d-block');
            p.classList.add('d-none');
        });

        // Mostra os selecionados
        let elements = document.querySelectorAll(`[unit="${option}"]`);

        elements.forEach(el => {
            el.classList.remove('d-none');
            el.classList.add('d-block');
        });
    }

    function changeSubjects(select) {
        $.ajax({
            url: select.attr('url'),
            type: 'POST',
            dataType: 'html',
            data: {
              'unit': select.val(),
              '_token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (html) {
                $('[name="subject"]').html(html);
            }
          });
    }
    
}